module.exports = __webpack_public_path__ + "static/images/c3686a3d067479d40dce0a214f8f9418.png";